import { AvatarProps, calculateSize } from './Avatar'
import IconDiamond from './IconDiamond'

type Props = { admin: boolean } & AvatarProps

export default function AvatarDiamond({ admin, size }: Props) {
  return <IconDiamond size={calculateSize(size)} color={admin ? '#D18EFC' : '#F56991'} />
}
